import WorkoutsManagerDashboard from './WorkoutsManagerDashboard';

export default WorkoutsManagerDashboard;
